<template lang="pug">
  .component-policy
    .inner-content(v-if="$is('listing')")
      .row
        .column.shrink
          dropdown(:icon="'fa fa-ellipsis-v fa-2x action'", :position="'bottom'")
            GroupButtons(:item="item", @itemUpdated="$emit('itemUpdated')")

        .column.shrink
          .field G{{item.id}}
          .field {{item.name}}
        .column
          .field Policies: {{item.policies.length}}
          .field(v-if="!item.global") Drivers: {{item.drivers}}
          .field(v-else) Global group


</template>

<script>
  import CardN from '../structure/CardN'
  import Dropdown from '../structure/foundation/Dropdown'
  import PolicyButtons from '../structure/ui/actions/PolicyButtons'
  import GroupButtons from '../structure/ui/actions/GroupButtons'

  export default {
    name: 'Group',
    components: {GroupButtons, PolicyButtons, Dropdown, CardN},
    props: ['item', 'type']
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// Group.vue?d142d08c